export enum GTMEvent {
  LIVE_CLASS_ACTION = 'lc-action',
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/GTMEvent.ts